import { render, staticRenderFns } from "./editmerchant.vue?vue&type=template&id=65ce7dbc&scoped=true&"
import script from "./editmerchant.vue?vue&type=script&lang=js&"
export * from "./editmerchant.vue?vue&type=script&lang=js&"
import style0 from "./editmerchant.vue?vue&type=style&index=0&id=65ce7dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce7dbc",
  null
  
)

export default component.exports